import { useCoordinator } from '../state/coordinator';
import { retryPending, useMiner } from './miner';
import { useWallet } from '../state/wallet';
export function initServices() {
 let previous = useCoordinator.getState().status;
 useCoordinator.subscribe(s => {
  if (s.status === 'online' && previous === 'offline') { if (useMiner.getState().pending > 0) retryPending(); void useWallet.getState().refreshBalance(); }
  previous = s.status;
 });
}
